  <div class="dialog-overlay d-flex justify-content-center align-items-center">
    <div class="generate-dialog shadow-lg">
      <div class="dialog-header text-center">
        <h2>Generating Your Course</h2>
      </div>
	      <span class="close-btn" (click)="close()">&times;</span>

              <div class="spinner-overlay">
               <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4"></mat-progress-spinner>
                </div>

      <div class="notify-block">
        <div class="notify-head mb-3">Your detailed course is being generated in the background.</div>
        <div class="notify-para">
          There are more requests in queue right now, so this may take a little longer.
		  We will notify you via email and push notification once it's ready.
        </div>
        <div class="notify-icons">
          <div class="notify-item">
            <i class="bi bi-envelope-fill icon-bg"></i><br />
            <span>Email</span>
          </div>
          <div class="notify-item">
            <i class="bi bi-bell-fill icon-bg"></i><br />
            <span>Push</span>
          </div>
        </div>
      </div>
      <button class="btn-add w-100 mt-3" (click)="close()">Minimize & Continue</button>
    </div>
  </div>